import logger from '~/utils/logger';

const TRANSLATION_BASE_PATH = `commons.components.need_help_with_auth`;

const getTranslationKey = (translationStr: string): string =>
  `${TRANSLATION_BASE_PATH}.${translationStr}`;

const RH_SCRIPT_TAG_ID = 'rh-script-element';

const listenToRhEvents = (() => {
  let eventsBinded = false;
  return ({
    onMeetingBooked,
    onDialogClosed
  }: {
    onMeetingBooked: () => void;
    onDialogClosed: () => void;
  }) => {
    if (eventsBinded) {
      return;
    }
    window.addEventListener('message', (event) => {
      if (event.origin?.includes('schedulehero')) {
        if (event.data?.type === 'PAGE_LOADED') {
          document.querySelectorAll('#rh-dialog').forEach((e) => {
            if (!e.children.length) {
              e.remove();
            }
          });
        } else if (event.data?.type === 'MEETING_BOOKED') {
          onMeetingBooked?.();
        } else if (event.data?.type === 'CLOSE_DIALOG') {
          onDialogClosed?.();
        }
      }
    });
    eventsBinded = true;
  };
})();

const rhUtil = (() => {
  let isScriptLoaded = false;
  let scriptLoadInProgress = false;
  return {
    init: ({
      formSelector,
      onLoad
    }: {
      formSelector: string;
      onLoad?: () => void;
    }) => {
      if (isScriptLoaded || scriptLoadInProgress) {
        return;
      }
      scriptLoadInProgress = true;

      const onRhLoaded = () => {
        if (!(<any>window).RevenueHero) {
          return false;
        }
        logger.info(`RevenueHero script loaded`);
        isScriptLoaded = true;
        (<any>window).hero = new (<any>window).RevenueHero({
          routerId: '3155'
        });
        (<any>window).hero.schedule(formSelector);
        onLoad?.();
        return true;
      };

      const pollForOnLoad = () => {
        // it could have been achieved with an onload event in the script tag
        // but that wont work because of CSP
        // hence done this way
        let retries = 0;
        const intervalId: ReturnType<typeof setInterval> = setInterval(() => {
          if (onRhLoaded()) {
            clearInterval(intervalId);
            scriptLoadInProgress = false;
            return;
          }
          retries++;
          if (retries <= 10) {
            clearInterval(intervalId);
            loadScript();
          }
        }, 500);
      };

      const loadScript = () => {
        const rhScript = document.createElement('script');
        rhScript.setAttribute('id', RH_SCRIPT_TAG_ID);
        rhScript.setAttribute(
          'src',
          `https://assets.revenuehero.io/scheduler.min.js`
        );
        document.head.appendChild(rhScript);
        pollForOnLoad();
      };

      loadScript();
    },
    cleanUp: () => {
      delete (<any>window).hero;
      delete (<any>window).RevenueHero;
      document.querySelector(`#${RH_SCRIPT_TAG_ID}`)?.remove();
      isScriptLoaded = false;
    }
  };
})();

export { getTranslationKey, rhUtil, listenToRhEvents };
